import api from '../redux/api';

function unwrap(response) {
  return response?.data?.data ?? response?.data;
}

export async function getZohoAuthUrl(dc = 'com') {
  const response = await api.get('/zoho/auth/login', { params: { dc } });
  return unwrap(response);
}
